export default __webpack_public_path__ + "static/media/feature-tryon.40dfef7b.jpg";